import axios from "axios";
import { SETTINGS } from "../../Settings";

export const AppEntryRepository = {
  getAll: (page, size, filterParams, orderBy, orderDirection) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntries/all`,
      method: "POST",
      params: {
        page: page,
        size: size,
        orderBy: orderBy,
        orderDirection: orderDirection,
      },
      data: filterParams,
    });
  },

  getById: (id) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntries/${id}`,
      method: "GET",
    });
  },

  getAvailableStatuses: (currentStatus) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntries/availableStatuses`,
      method: "GET",
      params: {
        currentStatus: currentStatus,
      },
    });
  },

  rejectForInvalidPayment: (id) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntries/reject`,
      method: "PUT",
      params: {
        id: id,
      },
    });
  },

  assignArchiveNumber: (id, archiveNumber) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntries/assignArchiveNumber`,
      method: "PUT",
      params: {
        id: id,
        archiveNumber: archiveNumber,
      },
    });
  },

  submitForCorrection: (id, reason) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntries/submitForCorrection`,
      method: "PUT",
      params: {
        id: id,
      },
      headers: {
        "Content-Type": "text/plain",
      },
      data: reason,
    });
  },

  submitForApproval: (id) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntries/submitForApproval`,
      method: "PUT",
      params: {
        id: id,
      },
    });
  },

  forwardToAuthorities: (id) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntries/forwardToAuthorities`,
      method: "PUT",
      params: {
        id: id,
      },
    });
  },

  getAllStatuses: () => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntries/statuses`,
      method: "GET",
    });
  },

  uploadAndSignFinalDecision: (id, file) => {
    const formData = new FormData();
    formData.append("finalDocument", file);
    formData.append("appEntryId", id);
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntries/uploadAndSignFinalDocument`,
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
      responseType: "blob",
    });
  },

  finalizeEntry: (appEntryId, isPositiveDecision) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/appEntries/finalizeAppEntry`,
      method: "POST",
      data: {
        appEntryId: appEntryId,
        isPositiveDecision: isPositiveDecision,
      },
    });
  },
};
